import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-62b78f0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = { class: "grid-layout" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c0" }, null, -1))
const _hoisted_7 = { class: "caja c1" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cliente: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Desde: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Hasta: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_13 = { class: "caja c2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold" }, [
  /*#__PURE__*/_createTextVNode(" Lote de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Reclamaciones ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "No: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "Autorización"),
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "Aseguradora"),
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "NSS"),
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "Paciente"),
    /*#__PURE__*/_createElementVNode("th", { class: "t cent" }, "Valor")
  ])
], -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "t der" }
const _hoisted_20 = { class: "t cent" }
const _hoisted_21 = { class: "t izq" }
const _hoisted_22 = { class: "t izq" }
const _hoisted_23 = { class: "t der" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "t izq bold" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_29 = { class: "bold der" }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "t der" }
const _hoisted_32 = { class: "t cent" }
const _hoisted_33 = { class: "t izq" }
const _hoisted_34 = { class: "t izq" }
const _hoisted_35 = { class: "t der" }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { class: "t izq bold" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_41 = { class: "bold der" }
const _hoisted_42 = { key: 4 }
const _hoisted_43 = { class: "t der" }
const _hoisted_44 = { class: "t cent" }
const _hoisted_45 = { class: "t izq" }
const _hoisted_46 = { class: "t izq" }
const _hoisted_47 = { class: "t der" }
const _hoisted_48 = { key: 5 }
const _hoisted_49 = { class: "t izq bold" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_53 = { class: "bold der" }
const _hoisted_54 = { key: 6 }
const _hoisted_55 = { class: "t der" }
const _hoisted_56 = { class: "t cent" }
const _hoisted_57 = { class: "t cent" }
const _hoisted_58 = { class: "t izq" }
const _hoisted_59 = { class: "t izq" }
const _hoisted_60 = { class: "t der" }
const _hoisted_61 = { key: 7 }
const _hoisted_62 = { class: "t izq bold" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_67 = { class: "bold der" }
const _hoisted_68 = { key: 8 }
const _hoisted_69 = { class: "t der" }
const _hoisted_70 = { class: "t cent" }
const _hoisted_71 = { class: "t izq" }
const _hoisted_72 = { class: "t izq" }
const _hoisted_73 = { class: "t der" }
const _hoisted_74 = { key: 9 }
const _hoisted_75 = { class: "t izq bold" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_79 = { class: "bold der" }
const _hoisted_80 = { class: "t izq bold" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der" }, null, -1))
const _hoisted_84 = { class: "bold der" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(this.documento.medico), 1),
          _createElementVNode("h5", null, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.documento.descCliente), 1)
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaDesde)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDatePlus(this.documento.fechaHasta)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaProceso)), 1)
          ], 512), [
            [_vShow, !_ctx.mostrarFechas()]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("h5", null, [
            _hoisted_15,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatSecuence(this.documento.no)), 1)
          ]),
          _withDirectives(_createElementVNode("h5", null, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaProceso)), 1)
          ], 512), [
            [_vShow, _ctx.mostrarFechas()]
          ])
        ])
      ]),
      _createElementVNode("table", null, [
        _hoisted_17,
        _createElementVNode("tbody", null, [
          (this.resumenServicios.cantconsults)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_18, "Consultas"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclamsconsults, (reclam, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_20, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ]))
          }), 128)),
          (this.resumenServicios.cantconsults)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                _createElementVNode("td", _hoisted_25, " Total Consultas: " + _toDisplayString(this.resumenServicios.cantconsults), 1),
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatNumber(this.resumenServicios.valconsults)), 1)
              ]))
            : _createCommentVNode("", true),
          (this.resumenServicios.cantemerg)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_30, "Emergencia"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclamsemerg, (reclam, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_32, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_33, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_34, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ]))
          }), 128)),
          (this.resumenServicios.cantemerg)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                _createElementVNode("td", _hoisted_37, " Total Emergencia: " + _toDisplayString(this.resumenServicios.cantemerg), 1),
                _hoisted_38,
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatNumber(this.resumenServicios.valemerg)), 1)
              ]))
            : _createCommentVNode("", true),
          (this.resumenServicios.canthospi)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_42, "Hospitalización"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclamshospi, (reclam, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_44, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_45, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_46, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ]))
          }), 128)),
          (this.resumenServicios.canthospi)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                _createElementVNode("td", _hoisted_49, " Total Hospitalización: " + _toDisplayString(this.resumenServicios.canthospi), 1),
                _hoisted_50,
                _hoisted_51,
                _hoisted_52,
                _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatNumber(this.resumenServicios.valhospi)), 1)
              ]))
            : _createCommentVNode("", true),
          (this.resumenServicios.cantproced)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_54, "Procedimientos"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclamsproced, (reclam, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_56, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_57, _toDisplayString(reclam.aseguradora), 1),
              _createElementVNode("td", _hoisted_58, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_59, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ]))
          }), 128)),
          (this.resumenServicios.cantproced)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                _createElementVNode("td", _hoisted_62, " Total Procedimientos: " + _toDisplayString(this.resumenServicios.cantproced), 1),
                _hoisted_63,
                _hoisted_64,
                _hoisted_65,
                _hoisted_66,
                _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.formatNumber(this.resumenServicios.valproced)), 1)
              ]))
            : _createCommentVNode("", true),
          (this.resumenServicios.cantcirug)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_68, "Cirugías"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reclamscirug, (reclam, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.formatDate(reclam.fechaProceso)), 1),
              _createElementVNode("td", _hoisted_70, _toDisplayString(reclam.autorizacion), 1),
              _createElementVNode("td", _hoisted_71, _toDisplayString(reclam.noAfiliado), 1),
              _createElementVNode("td", _hoisted_72, _toDisplayString(reclam.nombreAfiliado), 1),
              _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.formatNumber(reclam.reclamacion)), 1)
            ]))
          }), 128)),
          (this.resumenServicios.cantcirug)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                _createElementVNode("td", _hoisted_75, " Total Cirugías: " + _toDisplayString(this.resumenServicios.cantcirug), 1),
                _hoisted_76,
                _hoisted_77,
                _hoisted_78,
                _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.formatNumber(this.resumenServicios.valcirug)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_80, " Total Todos los Servicios: " + _toDisplayString(this.resumenServicios.cantconsults +
                this.resumenServicios.cantproced +
                this.resumenServicios.cantcirug +
                this.resumenServicios.canthospi +
                this.resumenServicios.cantemerg), 1),
            _hoisted_81,
            _hoisted_82,
            _hoisted_83,
            _createElementVNode("td", _hoisted_84, _toDisplayString(_ctx.formatNumber(
                this.resumenServicios.valconsults +
                  this.resumenServicios.valproced +
                  this.resumenServicios.valcirug +
                  this.resumenServicios.valhospi +
                  this.resumenServicios.valemerg
              )), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}